import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { StripeProvider } from './contexts/StripeContext';

function App() {
  return (
    <StripeProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </StripeProvider>
  );
}

export default App;